export { StickyTitleContainer, ResultChip } from "src/atoms/PLPGrid";
